import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  memo?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'MemoComponent',
  props: {
    memo: { default: undefined }
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card-without-title" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _withDirectives(_createVNode(SogDataLabel, { value: __props.memo }, null, 8, ["value"]), [
                  [_vShow, __props.memo]
                ]),
                _withDirectives(_createVNode(SogDataLabel, { value: "keine Bemerkung vorhanden" }, null, 512), [
                  [_vShow, !__props.memo]
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})